export function requestSuccess(materias) {
  return {
    type: '@materias/REQUEST_SUCCESS',
    payload: { materias },
  };
}
